// import { Map } from './Map';
import { Map } from 'maplibre-gl';
import type { StyleSpecification } from 'maplibre-gl';
import proj4 from "proj4";
import { bbox } from '@turf/turf';
// geographiclib is CommonJS. Official typings omit Polygon() on WGS84 even though
// it exists at runtime (PolygonArea helper).
import geographiclib from "geographiclib";

type GeodesicInverseResult = { s12?: number };
type GeodesicPolygonResult = { area?: number };
type GeodesicPolygon = {
  AddPoint: (lat: number, lon: number) => void;
  Compute: (reverse: boolean, sign: boolean) => GeodesicPolygonResult;
};
type GeodesicEllipsoid = {
  Inverse: (
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number,
  ) => GeodesicInverseResult;
  Polygon: (polyline?: boolean) => GeodesicPolygon;
};

const geographiclibModule = geographiclib as unknown as {
  Geodesic?: { WGS84?: GeodesicEllipsoid };
  default?: { Geodesic?: { WGS84?: GeodesicEllipsoid } };
};
const geod: GeodesicEllipsoid | undefined =
  geographiclibModule.Geodesic?.WGS84 ??
  geographiclibModule.default?.Geodesic?.WGS84;

if (!geod) {
  throw new Error("geographiclib Geodesic.WGS84 is unavailable");
}



export const CalculateBbox = (geojson: any) => {
  return bbox(geojson)
};
// const BASE_URL = 'https://api.geobox.ir';

// /**
//  * Concatinate to path a make a valid url path from them
//  *
//  * @param path1 first path to join
//  * @param path2 second path to join
//  * @returns the concatinated path
//  */
// export function joinPath(path1: string, path2: string) {
//   let [p1, p2] = [path1, path2];

//   if (path1.endsWith('/')) {
//     p1 = p1.slice(0, -1);
//   }
//   if (path2.startsWith('/')) {
//     p2 = p2.slice(1);
//   }
//   if (!path2.endsWith('/')) {
//     p2 += '/';
//   }

//   return `${p1}/${p2}`;
// }

// /**
//  * Makes a full url from a given relative url.
//  *
//  * @param relativeUrl the relative url to make a full url from.
//  * @returns the full (absolute) url of the input url.
//  */
// export function makeUrl(relativeUrl: string): string {
//   return joinPath(BASE_URL, relativeUrl);
// }

export const lineAngle = (point0: number[], point1: number[]) => {

  var dx = point1[0]-point0[0];
  var dy = point1[1]-point0[1];

  var angle = Math.atan2(dy, dx) * 180 / Math.PI;

  return Number(angle);
}

export const deegrees2meters = (px:number[]) => {
  //gist from https://gist.github.com/springmeyer/871897
  const x = px[0] * 20037508.34 / 180;
  let y = Math.log(Math.tan((90 + px[1]) * Math.PI / 360)) / (Math.PI / 180);
  y = y * 20037508.34 / 180;
  return [x, y]
}

export const meters2degrees = (px:number[]) => {
  //gist from https://gist.github.com/springmeyer/871897
  const lon = px[0] * 180 / 20037508.34;
  const lat = Math.atan(Math.exp(px[1] * Math.PI / 20037508.34)) * 360 / Math.PI - 90;
  return [lon, lat]
}

// export const uuid =() => {
//   return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
//       (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
//   );
// }

// export const formatSizeUnits =(bytes)=> {
//   if      (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
//   else if (bytes >= 1048576)    { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
//   else if (bytes >= 1024)       { bytes = (bytes / 1024).toFixed(2) + " KB"; }
//   else if (bytes > 1)           { bytes = bytes + " bytes"; }
//   else if (bytes == 1)          { bytes = bytes + " byte"; }
//   else                          { bytes = "0 bytes"; }
//   return bytes;
// }



// export const PersianToEnglishFormat = s => s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));

// export const LatLonToMercator = (lat, lon)=> {
//   var x, y;
//   try {
//     var rMajor = 6378137; //Equatorial Radius, WGS84
//     var shift = Math.PI * rMajor;
//     x = (lon * shift) / 180;
//     y = Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) / (Math.PI / 180);
//     y = (y * shift) / 180;
//   } catch (error) {
//     x = undefined;
//     y = undefined;
//   }

//   return { X: x, Y: y };
// }

// export const ConvertDegreeToDMS = (D) => {
//   return [
//     0 | D,
//     "° ",
//     0 | (((D = (D < 0 ? -D : D) + 1e-4) % 1) * 60),
//     "' ",
//     0 | (((D * 60) % 1) * 60),
//     '"',
//   ].join("");
// }

export const changeCoordinateSystem = (coords: number[], currentSRID: number, destinationSRID: number, zoneNumber: number | undefined) => {

  if (currentSRID === 3857 && destinationSRID === 4326){
    var lon = (coords[0] * 180) / 20037508.34;
    var lat = (Math.atan(Math.exp((coords[1] * Math.PI) / 20037508.34)) * 360) / Math.PI - 90;
    return [lon, lat];
  }else if (currentSRID === 4326 && destinationSRID === 3857){
    var x = coords[0] * 20037508.34 / 180;
    var y = Math.log(Math.tan((90 + coords[1]) * Math.PI / 360)) / (Math.PI / 180);
    y = y * 20037508.34 / 180;
    return [x, y]
  }else if (currentSRID === 4326 && String(destinationSRID).includes('326')) {
    if (!zoneNumber){
      var currentLocation = coords[0];
      if (currentLocation < -180) {
        currentLocation += 360;
      } else if (currentLocation > 180) {
        currentLocation -= 360;
      }
      zoneNumber = (Math.floor((currentLocation + 180) / 6) % 60) + 1;
  
    }
    
    const projDef = `+proj=utm +zone=${zoneNumber} +datum=WGS84 +units=m +no_defs`;
    proj4.defs([
      [
        "EPSG:4326",
        "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees"
      ],
      ["EPSG:AUTO", projDef]]);
    const utmCoordinate = proj4("EPSG:4326", "EPSG:AUTO", [coords[0], coords[1]]);
      return [utmCoordinate[0], utmCoordinate[1]];
  }else {
    return [];
  }
};

export const isObject = (obj: any) => {
  return typeof obj === 'object' && !Array.isArray(obj);
};

export const isArray = (arr: any) => {
  return typeof arr === 'object' && Array.isArray(arr);
};

export const webMercatorToLngLat = (x: number, y: number) => {
  const lon = (x * 180) / 20037508.34;
  const lat =
    (Math.atan(Math.exp((y * Math.PI) / 20037508.34)) * 360) / Math.PI - 90;
  return [lon, lat];
};

export const lngLatToWebMercator = (lon: number, lat: number) => {
  const x = (lon * 20037508.34) / 180;
  let y = Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) / (Math.PI / 180);
  y = (y * 20037508.34) / 180;
  return [x, y];
};

export const hexToRgba = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)},${parseInt(result[4], 16)?parseInt(result[4], 16):1})`
    : hex;
};

// export const hexToRgba = (hex: string) => {
//      // Remove the hash if it exists
//      console.log(hex)
//      if (hex.startsWith('rgba')) {
//         return hex; // Return as it is
//     } else if (hex.startsWith('rgb')) {
//         // If it's in rgb format, add the alpha
//         return hex.replace('rgb', 'rgba').replace(')', `, ${1})`);
//     } else if (hex.startsWith('#')) {
//       hex = hex.replace(/^#/, '');

//       // If the hex code is 4 or 8 characters, it includes an alpha channel
//       let hasAlpha = hex.length === 4 || hex.length === 8;
  
//       // Expand shorthand notation (#RGBA or #RGB)
//       if (hex.length === 4) {
//           hex = hex.split('').map(char => char + char).join('');
//       } else if (hex.length === 3) {
//           hex = hex.split('').map(char => char + char).join('');
//       }
  
//       // Convert the hex values to RGB
//       const r = parseInt(hex.slice(0, 2), 16);
//       const g = parseInt(hex.slice(2, 4), 16);
//       const b = parseInt(hex.slice(4, 6), 16);
  
//       // Convert the alpha value if present
//       let alpha = 1; // Default to 1 (fully opaque)
//       if (hasAlpha) {
//           alpha = parseInt(hex.slice(6, 8), 16) / 255; // Convert 0-255 to 0-1
//       }
  
//       return `rgba(${r}, ${g}, ${b}, ${alpha})`;
//     }
// }

// export const hexToRgb = (hex) => {
//   var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
//   return result ? `rgb(${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)})`
//       : hex;
// }

export const rgbToHex = (r: number, g: number, b: number) => {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

// export const getDeviceType = () => {
//   const ua = navigator.userAgent;
//   if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
//       return "tablet";
//   }
//   if (
//       /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
//           ua
//       )
//   ) {
//       return "mobile";
//   }
//   return "desktop";
// };

// export const object_equals = ( x, y, skipKeys ) => {
//   skipKeys = skipKeys || [];
//   if ( x === y ) return true;
//   if ( ! ( x instanceof Object ) || ! ( y instanceof Object ) ) return false;

//   if ( x.constructor !== y.constructor ) return false;
//   for ( var p in x ) {
//       if(skipKeys.includes(p)) continue;
//       if ( ! x.hasOwnProperty( p ) ) continue;
//       if ( ! y.hasOwnProperty( p ) ) return false;
//       if ( x[ p ] === y[ p ] ) continue;
//       if ( typeof( x[ p ] ) !== "object" ) return false;
//       if ( !object_equals( x[ p ],  y[ p ], skipKeys ) ) return false;
//   }

//   for ( p in y )
//       if(skipKeys.includes(p)) continue;
//       if ( y.hasOwnProperty( p ) && ! x.hasOwnProperty( p ) )
//       return false;
//   return true;
// }


// export class GetMapThumbnail {
//   saveClipped(map: Map): HTMLCanvasElement {
//       const mapCanvas = map.getCanvas();

//       const w = 300;
//       const h = 200;

//       const finalResizedCanvas = document.createElement("canvas");
//       finalResizedCanvas.width = w;
//       finalResizedCanvas.height = h;

//       const finalResizedContext = finalResizedCanvas.getContext("2d");
//       if (!finalResizedContext) {
//           throw new Error("Failed to create 2D context.");
//       }

//       finalResizedContext.drawImage(mapCanvas, 0, 0, w, h);

//       return finalResizedCanvas;
//   }
// }


export class GetMapThumbnail {

  saveClipped(map:Map): HTMLCanvasElement{
      const mapCanvas = map.getCanvas();

      const w = 300;
      const h = 200;

      const actualWidth = mapCanvas.width / window.devicePixelRatio;
      const actualHeight = mapCanvas.height / window.devicePixelRatio;

      const wRatio = actualWidth / w;
      const hRatio = actualHeight / h;

      const scale = Math.min(wRatio, hRatio);
      const W = scale * w;
      const H = scale * h;

      const startX = Math.floor((actualWidth - W) / 2);
      const startY = Math.floor((actualHeight - H) / 2);

      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = mapCanvas.width;
      tempCanvas.height = mapCanvas.height;

      const ctx2d = tempCanvas.getContext('2d');
      ctx2d?.drawImage(mapCanvas, 0, 0);


      const finalCanvas = document.createElement('canvas');
      finalCanvas.width = w;
      finalCanvas.height = h;

      const finalCtx = finalCanvas.getContext('2d');
      finalCtx?.drawImage(
          tempCanvas,
          startX * window.devicePixelRatio,
          startY * window.devicePixelRatio,
          W * window.devicePixelRatio,
          H * window.devicePixelRatio,
          0, 0, w, h
      );

      return finalCanvas;
  }
}


// export const  jalali_to_gregorian =(jy, jm, jd) => {
//   jy = Number(jy);
//   jm = Number(jm);
//   jd = Number(jd);
//   var gy = (jy <= 979) ? 621 : 1600;
//   jy -= (jy <= 979) ? 0 : 979;
//   var days = (365 * jy) + ((parseInt(jy / 33)) * 8) + (parseInt(((jy % 33) + 3) / 4))
//       + 78 + jd + ((jm < 7) ? (jm - 1) * 31 : ((jm - 7) * 30) + 186);
//   gy += 400 * (parseInt(days / 146097));
//   days %= 146097;
//   if (days > 36524) {
//       gy += 100 * (parseInt(--days / 36524));
//       days %= 36524;
//       if (days >= 365) days++;
//   }
//   gy += 4 * (parseInt((days) / 1461));
//   days %= 1461;
//   gy += parseInt((days - 1) / 365);
//   if (days > 365) days = (days - 1) % 365;
//   var gd = days + 1;
//   var sal_a = [0, 31, ((gy % 4 == 0 && gy % 100 != 0) || (gy % 400 == 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
//   var gm
//   for (gm = 0; gm < 13; gm++) {
//       var v = sal_a[gm];
//       if (gd <= v) break;
//       gd -= v;
//   }
//   if (gm < 10) gm = `0${gm}`
//   if (gd < 10) gd = `0${gd}`
//   gm = `${gm}`
//   gd = `${gd}`
//   gy = `${gy}`
//   return [gy, gm, gd];
// }

// export const arrayMove = (arr: Array<any>, old_index:number, new_index: number) => {

//   if (new_index >= arr.length || new_index < 0) return arr;

//   // if (new_index >= arr.length) {
//   //     var k = new_index - arr.length + 1;
//   //     while (k--) {
//   //         arr.push(undefined);
//   //     }
//   // }
//   arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
//   return arr; // for testing
// };


export const chunk = <T>(array: T[], size: number): T[][] => Array.from(
  { length: Math.ceil(array.length / size) },
  (v, i) => array.slice(i * size, i * size + size),
);

export const zip = <T>(...arrays: T[][]): T[][] => (
  arrays[0].map((first, i) => arrays.slice(1).reduce((acc, other) => [...acc, other[i]], [first]))
);

export const toPair = <T>(stop: [T] | [T, T]): [T | null, T] => (
  (stop.length === 2 ? stop : [null, ...stop])
);

export const toBins = <T, K>(stops: [T, K][]): [T | [T, T], K][] => {
  const other = stops.find(([input]) => input === null);
  return stops.reduce((acc, [low, out], i) => {
    if (i === stops.length - 1) acc.push([low, out]);
    else if (out !== other?.[1]) acc.push([[low, stops[i + 1][0]], out]);
    return acc;
  }, [] as [T | [T, T], K][]);
};

export const insert = (arr: any[], index: number, newItem:any) => {
  return [
    ...arr.slice(0, index),
    newItem,
    ...arr.slice(index)
  ]
} 

export const colorNameToRGBA = (color: string) => {
  let tempDiv = document.createElement("div");
  tempDiv.style.color = color;
  document.body.appendChild(tempDiv);

  let rgb = window.getComputedStyle(tempDiv).color;
  document.body.removeChild(tempDiv);

  let rgbValues = <string[]>rgb.match(/\d+/g); // Extracts the RGB values
  return `rgba(${rgbValues[0]},${rgbValues[1]},${rgbValues[2]},${rgbValues[3] || 1})` //rgbToHex(parseInt((<string[]>rgbValues)[0]), parseInt((<string[]>rgbValues)[1]), parseInt((<string[]>rgbValues)[2]));
}


// const colors = {
//   "aliceblue": "#F0F8FF",
//   "antiquewhite": "#FAEBD7",
//   "aqua": "#00FFFF",
//   "aquamarine": "#7FFFD4",
//   "azure": "#F0FFFF",
//   "beige": "#F5F5DC",
//   "bisque": "#FFE4C4",
//   "black": "#000000",
//   "blanchedalmond": "#FFEBCD",
//   "blue": "#0000FF",
//   "blueviolet": "#8A2BE2",
//   "brown": "#A52A2A",
//   "burlywood": "#DEB887",
//   "cadetblue": "#5F9EA0",
//   "chartreuse": "#7FFF00",
//   "chocolate": "#D2691E",
//   "coral": "#FF7F50",
//   "cornflowerblue": "#6495ED",
//   "cornsilk": "#FFF8DC",
//   "crimson": "#DC143C",
//   "cyan": "#00FFFF",
//   "darkblue": "#00008B",
//   "darkcyan": "#008B8B",
//   "darkgoldenrod": "#B8860B",
//   "darkgray": "#A9A9A9",
//   "darkgreen": "#006400",
//   "darkkhaki": "#BDB76B",
//   "darkmagenta": "#8B008B",
//   "darkolivegreen": "#556B2F",
//   "darkorange": "#FF8C00",
//   "darkorchid": "#9932CC",
//   "darkred": "#8B0000",
//   "darksalmon": "#E9967A",
//   "darkseagreen": "#8FBC8F",
//   "darkslateblue": "#483D8B",
//   "darkslategray": "#2F4F4F",
//   "darkturquoise": "#00CED1",
//   "darkviolet": "#9400D3",
//   "deeppink": "#FF1493",
//   "deepskyblue": "#00BFFF",
//   "dimgray": "#696969",
//   "dodgerblue": "#1E90FF",
//   "firebrick": "#B22222",
//   "floralwhite": "#FFFAF0",
//   "forestgreen": "#228B22",
//   "fuchsia": "#FF00FF",
//   "gainsboro": "#DCDCDC",
//   "ghostwhite": "#F8F8FF",
//   "gold": "#FFD700",
//   "goldenrod": "#DAA520",
//   "gray": "#808080",
//   "green": "#008000",
//   "greenyellow": "#ADFF2F",
//   "honeydew": "#F0FFF0",
//   "hotpink": "#FF69B4",
//   "indianred": "#CD5C5C",
//   "indigo": "#4B0082",
//   "ivory": "#FFFFF0",
//   "khaki": "#F0E68C",
//   "lavender": "#E6E6FA",
//   "lavenderblush": "#FFF0F5",
//   "lawngreen": "#7CFC00",
//   "lemonchiffon": "#FFFACD",
//   "lightblue": "#ADD8E6",
//   "lightcoral": "#F08080",
//   "lightcyan": "#E0FFFF",
//   "lightgoldenrodyellow": "#FAFAD2",
//   "lightgray": "#D3D3D3",
//   "lightgreen": "#90EE90",
//   "lightpink": "#FFB6C1",
//   "lightsalmon": "#FFA07A",
//   "lightseagreen": "#20B2AA",
//   "lightskyblue": "#87CEFA",
//   "lightslategray": "#778899",
//   "lightsteelblue": "#B0C4DE",
//   "lightyellow": "#FFFFE0",
//   "lime": "#00FF00",
//   "limegreen": "#32CD32",
//   "linen": "#FAF0E6",
//   "magenta": "#FF00FF",
//   "maroon": "#800000",
//   "mediumaquamarine": "#66CDAA",
//   "mediumblue": "#0000CD",
//   "mediumorchid": "#BA55D3",
//   "mediumpurple": "#9370DB",
//   "mediumseagreen": "#3CB371",
//   "mediumslateblue": "#7B68EE",
//   "mediumspringgreen": "#00FA9A",
//   "mediumturquoise": "#48D1CC",
//   "mediumvioletred": "#C71585",
//   "midnightblue": "#191970",
//   "mintcream": "#F5FFFA",
//   "mistyrose": "#FFE4E1",
//   "moccasin": "#FFE4B5",
//   "navajowhite": "#FFDEAD",
//   "navy": "#000080",
//   "oldlace": "#FDF5E6",
//   "olive": "#808000",
//   "olivedrab": "#6B8E23",
//   "orange": "#FFA500",
//   "orangered": "#FF4500",
//   "orchid": "#DA70D6",
//   "palegoldenrod": "#EEE8AA",
//   "palegreen": "#98FB98",
//   "paleturquoise": "#AFEEEE",
//   "palevioletred": "#DB7093",
//   "papayawhip": "#FFEFD5",
//   "peachpuff": "#FFDAB9",
//   "peru": "#CD853F",
//   "pink": "#FFC0CB",
//   "plum": "#DDA0DD",
//   "powderblue": "#B0E0E6",
//   "purple": "#800080",
//   "red": "#FF0000",
//   "rosybrown": "#BC8F8F",
//   "royalblue": "#4169E1",
//   "saddlebrown": "#8B4513",
//   "salmon": "#FA8072",
//   "sandybrown": "#F4A460",
//   "seagreen": "#2E8B57",
//   "seashell": "#FFF5EE",
//   "sienna": "#A0522D",
//   "silver": "#C0C0C0",
//   "skyblue": "#87CEEB",
//   "slateblue": "#6A5ACD",
//   "slategray": "#708090",
//   "snow": "#FFFAFA",
//   "springgreen": "#00FF7F",
//   "steelblue": "#4682B4",
//   "tan": "#D2B48C",
//   "teal": "#008080",
//   "thistle": "#D8BFD8",
//   "tomato": "#FF6347",
//   "turquoise": "#40E0D0",
//   "violet": "#EE82EE",
//   "wheat": "#F5DEB3",
//   "white": "#FFFFFF",
//   "whitesmoke": "#F5F5F5",
//   "yellow": "#FFFF00",
//   "yellowgreen": "#9ACD32"
// };

// function colorNameToHex(color) {
//   return colors[color.toLowerCase()] || null;
// }


export function escapeHTML(str:any) {
  if (typeof str !== 'string') {
      return str;
  }
  return str.replace(/[&<>'"]/g, function (tag:any) {
      const charsToReplace = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          "'": '&#39;',
          '"': '&quot;',
      };
      return (<any>charsToReplace)[tag] || tag;
  });
} 


/**
 * Geodesic line length in meters (WGS84).
 * Equivalent spirit to PostGIS `ST_Length(geom::geography)`.
 */
export const lineLengthPostGIS = (coordinates: number[][]): number => {
  try {
    if (!Array.isArray(coordinates) || coordinates.length < 2) return 0;

    let total = 0;

    for (let i = 0; i < coordinates.length - 1; i++) {
      const [lon1, lat1] = coordinates[i] ?? [];
      const [lon2, lat2] = coordinates[i + 1] ?? [];
      if (
        ![lon1, lat1, lon2, lat2].every(
          (n) => typeof n === "number" && Number.isFinite(n),
        )
      ) {
        continue;
      }

      const r = geod.Inverse(lat1, lon1, lat2, lon2);
      total += Number(r.s12) || 0; // meters
    }

    return total;
  } catch {
    return 0;
  }
};

/**
 * Geodesic polygon area in m² (WGS84), outer ring only.
 * Equivalent spirit to PostGIS `ST_Area(geom::geography)`.
 */
export const polygonAreaPostGIS = (coordinates: number[][][]): number => {
  try {
    const ring = coordinates?.[0];
    if (!Array.isArray(ring) || ring.length < 3) return 0;

    const poly = geod.Polygon();

    for (const point of ring) {
      const lon = point?.[0];
      const lat = point?.[1];
      if (
        typeof lon !== "number" ||
        typeof lat !== "number" ||
        !Number.isFinite(lon) ||
        !Number.isFinite(lat)
      ) {
        continue;
      }
      poly.AddPoint(lat, lon);
    }

    const r = poly.Compute(false, true);
    return Math.abs(Number(r.area) || 0); // m²
  } catch {
    return 0;
  }
};

const EPHEMERAL_GRAPHICS_LAYER_PREFIXES = [
  'gl-draw',
  'geobox-client-map-sketch',
  'geobox-gl-snap',
  'geobox-gl-map-models',
  'geobox-model-probe-',
  'geobox-gl-vector-basemap--',
];
const EPHEMERAL_GRAPHICS_SOURCE_PREFIXES = [
  'gl-draw',
  'mapbox-gl-draw',
  'geobox-client-map-sketch',
  'geobox-gl-snap',
  'geobox-gl-map-models',
  'geobox-gl-vector-basemap--',
];

const EPHEMERAL_GRAPHICS_LAYER_IDS = new Set([
  'geobox-gl-splash-circle',
  'geobox-gl-base-map',
  'geobox-gl-custom-base-map',
]);

const EPHEMERAL_GRAPHICS_SOURCE_IDS = new Set([
  'geobox-gl-splash-circle',
  'geobox-gl-base-map',
  'geobox-gl-custom-base-map',
]);

/** Internal MapLibre layers/sources (snap guides, pulsing dot, etc.) — never persisted. */
export function isInternalRuntimeMapLayerId(layerId: string): boolean {
  if (EPHEMERAL_GRAPHICS_LAYER_IDS.has(layerId)) return true;
  return EPHEMERAL_GRAPHICS_LAYER_PREFIXES.some((prefix) => layerId.startsWith(prefix));
}

export function isInternalRuntimeMapSourceId(sourceId: string): boolean {
  if (EPHEMERAL_GRAPHICS_SOURCE_IDS.has(sourceId)) return true;
  return EPHEMERAL_GRAPHICS_SOURCE_PREFIXES.some((prefix) => sourceId.startsWith(prefix));
}

/** Layers added at runtime for sketches, annotations, and gl-draw — not part of persisted map style. */
export function isEphemeralGraphicsLayerId(layerId: string): boolean {
  return isInternalRuntimeMapLayerId(layerId);
}

export function isEphemeralGraphicsSourceId(sourceId: string): boolean {
  return isInternalRuntimeMapSourceId(sourceId);
}

/** Parse `geobox://vector|view|tileset/{uuid}` source ids from map style. */
export function parseGeoboxSourceRef(
  sourceId: string,
): { type: string; uuid: string } | null {
  const match = String(sourceId).match(
    /^geobox:\/\/(vector|view|tileset|mosaic|raster|hillshade)\/([^/?#]+)/,
  );
  if (!match) return null;
  return { type: match[1], uuid: match[2] };
}

export function isGeoboxPersistedDataSourceId(sourceId: string): boolean {
  return parseGeoboxSourceRef(sourceId) !== null;
}

export function isLiveGeoboxLayerSource(source: unknown): boolean {
  return (
    !!source &&
    typeof source === 'object' &&
    (typeof (source as { getFeatures?: unknown }).getFeatures === 'function' ||
      typeof (source as { getFields?: unknown }).getFields === 'function')
  );
}

/** True when an object is Geobox layer metadata, not a bare MapLibre source spec. */
export function isGeoboxLayerMetadata(source: unknown): boolean {
  if (!source || typeof source !== 'object') return false;
  if (isLiveGeoboxLayerSource(source)) return true;

  const entry = source as Record<string, unknown>;
  return (
    typeof entry.layer_type === 'string' ||
    typeof entry.layer_source_type === 'string' ||
    typeof entry.uuid === 'string' ||
    (typeof entry.id === 'string' && typeof entry.name === 'string')
  );
}

export function isRasterHillshadeSubLayerId(layerId: string): boolean {
  return layerId.endsWith('$hillshade') || layerId.endsWith('$raster');
}

/** Build minimal Geobox layer metadata from a `geobox://` source id. */
export function createGeoboxLayerStubFromSourceRef(layer: {
  id?: string;
  source?: string;
  is_terrain?: boolean;
}): Record<string, unknown> | undefined {
  const parsed = parseGeoboxSourceRef(String(layer.source ?? ''));
  if (!parsed) return undefined;

  return {
    name: String(layer.id ?? ''),
    is_terrain: !!layer.is_terrain,
  };
}

/**
 * Ensure hillshade sub-layers saved with a raster/mosaic parent keep their DEM
 * source and hide the parent raster layer when hillshade is active.
 */
export function ensureRasterHillshadeStyleIntegrity(
  style: StyleSpecification,
): void {
  if (!style.layers?.length) return;
  if (!style.sources) style.sources = {};

  for (const layer of style.layers) {
    const layerId = String(layer.id ?? '');
    if (!layerId.endsWith('$hillshade') || layer.type !== 'hillshade') continue;

    const parentId = layerId.slice(0, -'$hillshade'.length);
    const parentStyleLayer = style.layers.find((entry) => entry.id === parentId) as
      | (typeof style.layers)[number] & { source?: string; layout?: { visibility?: string } }
      | undefined;
    if (!parentStyleLayer?.source) continue;

    const hillshadeSourceId = String((layer as { source?: string }).source ?? '');
    if (hillshadeSourceId && !style.sources[hillshadeSourceId]) {
      const parentSource = style.sources[String(parentStyleLayer.source)] as
        | { url?: string }
        | undefined;
      if (parentSource?.url) {
        style.sources[hillshadeSourceId] = {
          type: 'raster-dem',
          url: parentSource.url,
        };
      }
    }

    const parentLayout = parentStyleLayer.layout ?? {};
    if (parentLayout.visibility !== 'none') {
      parentStyleLayer.layout = { ...parentLayout, visibility: 'none' };
    }
  }
}

/** Resolve layer metadata from style layer and/or its MapLibre source entry. */
export function resolveGeoboxLayerMetadata(
  layer: { source?: string; [key: string]: unknown },
  styleSources?: Record<string, unknown>,
): Record<string, unknown> | undefined {
  const fromLayer =
    (layer['geobox-layer'] as Record<string, unknown> | undefined) ??
    (layer['geobox-source'] as Record<string, unknown> | undefined);

  if (fromLayer && isGeoboxLayerMetadata(fromLayer)) return fromLayer;

  const sourceId = layer.source;
  if (!sourceId || !styleSources) return undefined;

  const sourceEntry = styleSources[sourceId] as Record<string, unknown> | undefined;
  if (!sourceEntry) return undefined;

  const fromSource =
    (sourceEntry['geobox-layer'] as Record<string, unknown> | undefined) ??
    (sourceEntry['geobox-source'] as Record<string, unknown> | undefined);

  if (fromSource && isGeoboxLayerMetadata(fromSource)) return fromSource;

  return undefined;
}

export type AuthorizeMapRequest = (url: string) => {
  url: string;
  headers?: Record<string, string>;
};

export type FilterInaccessibleMapSourcesOptions = {
  /** Mirror MapLibre `transformRequest` so probes use the same auth as tiles. */
  authorizeRequest?: AuthorizeMapRequest;
  /** Per-source timeout in ms (default 8000). */
  timeoutMs?: number;
};

function shouldProbeMapSourceUrl(
  source: { type?: string; url?: unknown },
  url: string,
): boolean {
  if (!/^https?:\/\//i.test(url)) return false;
  const type = source.type;
  if (type === 'vector' || type === 'raster' || type === 'raster-dem') return true;
  return /tilejson\.json(\?|$)/i.test(url);
}

/**
 * Probe TileJSON / remote source URLs and drop sources (and their layers) that
 * are inaccessible (404/403/401/network). Prevents MapLibre style load from
 * stalling when shared maps reference deleted or unauthorized rasters/vectors.
 */
export async function filterInaccessibleMapSources(
  style: StyleSpecification,
  options: FilterInaccessibleMapSourcesOptions = {},
): Promise<{ style: StyleSpecification; removedSourceIds: string[] }> {
  const sources = style.sources ?? {};
  const timeoutMs = options.timeoutMs ?? 8000;
  const authorizeRequest = options.authorizeRequest;

  const probes = Object.entries(sources).map(async ([sourceId, source]) => {
    const url = (source as { url?: unknown })?.url;
    if (typeof url !== 'string' || !url) {
      return { sourceId, ok: true as const };
    }
    if (!shouldProbeMapSourceUrl(source as { type?: string; url?: unknown }, url)) {
      return { sourceId, ok: true as const };
    }

    const auth = authorizeRequest?.(url) ?? { url };
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);

    try {
      const response = await fetch(auth.url, {
        method: 'GET',
        headers: auth.headers,
        signal: controller.signal,
      });
      if (response.ok) return { sourceId, ok: true as const };
      // Treat auth/not-found/server errors as inaccessible so the map stays usable.
      return { sourceId, ok: false as const };
    } catch {
      return { sourceId, ok: false as const };
    } finally {
      clearTimeout(timer);
    }
  });

  const results = await Promise.all(probes);
  const removedSourceIds = results
    .filter((result) => !result.ok)
    .map((result) => result.sourceId);

  if (removedSourceIds.length === 0) {
    return { style, removedSourceIds };
  }

  const removed = new Set(removedSourceIds);
  const nextSources = { ...sources };
  for (const id of removed) {
    delete nextSources[id];
  }

  const nextLayers = (style.layers ?? []).filter((layer) => {
    const sourceId = (layer as { source?: string }).source;
    return !(sourceId && removed.has(sourceId));
  });

  return {
    style: {
      ...style,
      sources: nextSources,
      layers: nextLayers,
    },
    removedSourceIds,
  };
}

/**
 * Deep-clone a style into plain JSON safe for MapLibre worker transfer.
 * `getStyle(true)` may attach live Geobox SDK class instances (minified names
 * like `c`) that fail serialization with "unregistered class".
 */
export function toPlainMapStyle(style: StyleSpecification): StyleSpecification {
  const LAYER_KEYS = [
    'id',
    'type',
    'metadata',
    'source',
    'source-layer',
    'minzoom',
    'maxzoom',
    'filter',
    'layout',
    'paint',
    'slot',
  ] as const;

  const SOURCE_KEYS = [
    'type',
    'url',
    'tiles',
    'bounds',
    'scheme',
    'minzoom',
    'maxzoom',
    'attribution',
    'volatile',
    'tileSize',
    'data',
    'lineMetrics',
    'generateId',
    'cluster',
    'clusterRadius',
    'clusterMaxZoom',
    'clusterMinPoints',
    'clusterProperties',
    'promoteId',
    'buffer',
    'tolerance',
    'filter',
    'encoding',
    'duration',
    'coordinates',
    'urls',
  ] as const;

  const replacer = (_key: string, value: unknown) => {
    if (typeof value === 'function') return undefined;
    if (value == null || typeof value !== 'object') return value;
    if (Array.isArray(value) || ArrayBuffer.isView(value) || value instanceof Date) {
      return value;
    }
    const ctor = (value as object).constructor;
    if (ctor && ctor !== Object) {
      // Color-like SDK / MapLibre values → CSS string when possible
      if (typeof (value as { toString?: () => string }).toString === 'function') {
        const asString = (value as { toString: () => string }).toString();
        if (
          typeof asString === 'string' &&
          asString !== '[object Object]' &&
          /^(#|rgb|hsl|hsv)/i.test(asString)
        ) {
          return asString;
        }
      }
      const plain: Record<string, unknown> = {};
      for (const key of Object.keys(value as object)) {
        plain[key] = (value as Record<string, unknown>)[key];
      }
      return plain;
    }
    return value;
  };

  let plain: StyleSpecification;
  try {
    plain = JSON.parse(JSON.stringify(style, replacer)) as StyleSpecification;
  } catch {
    plain = JSON.parse(JSON.stringify({
      ...style,
      layers: (style.layers ?? []).map((layer) => {
        const next = { ...(layer as object) } as Record<string, unknown>;
        delete next['geobox-layer'];
        delete next['geobox-source'];
        return next;
      }),
      sources: Object.fromEntries(
        Object.entries(style.sources ?? {}).map(([id, source]) => {
          const next = { ...(source as object) } as Record<string, unknown>;
          delete next['geobox-layer'];
          delete next['geobox-source'];
          return [id, next];
        }),
      ),
    }, replacer)) as StyleSpecification;
  }

  plain.layers = (plain.layers ?? []).map((layer) => {
    const next: Record<string, unknown> = {};
    for (const key of LAYER_KEYS) {
      if (key in (layer as object)) {
        next[key] = (layer as Record<string, unknown>)[key];
      }
    }
    return next as (typeof plain.layers)[number];
  });

  plain.sources = Object.fromEntries(
    Object.entries(plain.sources ?? {}).map(([id, source]) => {
      const next: Record<string, unknown> = {};
      for (const key of SOURCE_KEYS) {
        if (key in (source as object)) {
          next[key] = (source as Record<string, unknown>)[key];
        }
      }
      return [id, next];
    }),
  ) as StyleSpecification['sources'];

  return plain;
}

export type StripEphemeralGraphicsOptions = {
  /**
   * When true, keep original layer/source object references (including live
   * `geobox-layer` / `geobox-source` SDK methods from `getStyle(true)`).
   * Use on map load. Default false clones via JSON for save/export.
   */
  preserveLiveMetadata?: boolean;
};

/** Remove sketch/annotation/gl-draw layers and sources from a style before save or load. */
export function stripEphemeralGraphicsFromStyle(
  style: StyleSpecification,
  options: StripEphemeralGraphicsOptions = {},
): StyleSpecification {
  const removedSources = new Set<string>();

  const layers = (style.layers ?? []).filter((layer) => {
    const id = String(layer.id ?? '');
    if (!isEphemeralGraphicsLayerId(id)) return true;
    const source = (layer as { source?: string }).source;
    if (source) removedSources.add(source);
    return false;
  });

  const sources = { ...(style.sources ?? {}) };
  for (const sourceId of Object.keys(sources)) {
    if (isGeoboxPersistedDataSourceId(sourceId)) continue;
    if (isEphemeralGraphicsSourceId(sourceId) || removedSources.has(sourceId)) {
      delete sources[sourceId];
    }
  }

  if (options.preserveLiveMetadata) {
    return {
      ...style,
      layers,
      sources,
    };
  }

  const next = JSON.parse(JSON.stringify(style)) as StyleSpecification;
  next.layers = layers.map((layer) =>
    JSON.parse(JSON.stringify(layer)) as (typeof layers)[number],
  );
  next.sources = JSON.parse(JSON.stringify(sources)) as typeof sources;
  return next;
}

/**
 * Recover placed 3D models that were incorrectly persisted as the
 * `geobox-gl-map-models` GeoJSON source inside map style.
 */
export function extractMapModelsFromStyle(style: StyleSpecification | null | undefined): Array<{
  name: string;
  alias: string | null;
  desc: string | null;
  obj: string;
  loc: [number, number, number];
  rotation: [number, number, number];
  scale: number;
  min_zoom: number;
  max_zoom: number;
  id?: string;
}> {
  const source = style?.sources?.['geobox-gl-map-models'] as
    | { type?: string; data?: GeoJSON.FeatureCollection | string }
    | undefined;
  if (!source || source.type !== 'geojson' || !source.data || typeof source.data === 'string') {
    return [];
  }

  const features = source.data.features;
  if (!Array.isArray(features)) return [];

  const out: Array<{
    name: string;
    alias: string | null;
    desc: string | null;
    obj: string;
    loc: [number, number, number];
    rotation: [number, number, number];
    scale: number;
    min_zoom: number;
    max_zoom: number;
    id?: string;
  }> = [];

  for (let index = 0; index < features.length; index += 1) {
    const feature = features[index];
    const props = (feature?.properties ?? {}) as Record<string, unknown>;
    const obj = props.__mapModelObj ?? props.obj;
    const coords = feature?.geometry && 'coordinates' in feature.geometry
      ? (feature.geometry as GeoJSON.Point | GeoJSON.MultiPoint).coordinates
      : null;
    if (!obj || !coords) continue;

    const point = Array.isArray(coords[0]) ? (coords as number[][])[0] : (coords as number[]);
    if (!point || point.length < 2) continue;

    out.push({
      id: typeof props.__mapModelId === 'string' ? props.__mapModelId : undefined,
      name: String(props.name ?? `Model ${index + 1}`),
      alias: null,
      desc: null,
      obj: String(obj),
      loc: [Number(point[0]), Number(point[1]), Number(point[2] ?? 0)],
      rotation: [0, 0, 0],
      scale: 1,
      min_zoom: 0,
      max_zoom: 22,
    });
  }

  return out;
}

/**
 * Permalink camera hash: `#zoom/lat/lng/pitch/bearing`
 * (same order written by geobox-client `updateHash`).
 */
export type MapCameraHashState = {
  zoom: number;
  lat: number;
  lng: number;
  pitch: number;
  bearing: number;
};

const MAP_CAMERA_HASH =
  /^(\d+(?:\.\d+)?)\/(-?\d+(?:\.\d+)?)\/(-?\d+(?:\.\d+)?)\/(-?\d+(?:\.\d+)?)\/(-?\d+(?:\.\d+)?)$/;

/** Default camera from the Map constructor (`center: [1, 15], zoom: 3`). */
export const CONSTRUCTOR_DEFAULT_CAMERA: MapCameraHashState = {
  zoom: 3,
  lat: 15,
  lng: 1,
  pitch: 0,
  bearing: 0,
};

export function parseMapCameraHash(
  hash: string = typeof window !== 'undefined' ? window.location.hash : '',
): MapCameraHashState | null {
  const body = String(hash || '').replace(/^#/, '').trim();
  if (!body || body.toLowerCase().startsWith('preview')) return null;
  const match = body.match(MAP_CAMERA_HASH);
  if (!match) return null;
  const zoom = Number(match[1]);
  const lat = Number(match[2]);
  const lng = Number(match[3]);
  const pitch = Number(match[4]);
  const bearing = Number(match[5]);
  if (![zoom, lat, lng, pitch, bearing].every((n) => Number.isFinite(n))) {
    return null;
  }
  return { zoom, lat, lng, pitch, bearing };
}

export function isConstructorDefaultCamera(
  camera: MapCameraHashState | null | undefined,
  epsilon = 1e-3,
): boolean {
  if (!camera) return false;
  return (
    Math.abs(camera.zoom - CONSTRUCTOR_DEFAULT_CAMERA.zoom) <= epsilon &&
    Math.abs(camera.lat - CONSTRUCTOR_DEFAULT_CAMERA.lat) <= epsilon &&
    Math.abs(camera.lng - CONSTRUCTOR_DEFAULT_CAMERA.lng) <= epsilon
  );
}

/**
 * True when the URL hash is a usable camera permalink that should override
 * saved view_settings/extent. Constructor-default hashes are ignored — they are
 * often stamped by the host app before openMap finishes applying the saved view.
 */
export function shouldPreferCameraHash(
  hash: string = typeof window !== 'undefined' ? window.location.hash : '',
): boolean {
  const camera = parseMapCameraHash(hash);
  return !!camera && !isConstructorDefaultCamera(camera);
}

export {proj4}